var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M182.742 71.875H117.266C93.5156 71.875 79.6875 85.7813 79.6875 109.609V190.313C79.6875 214.531 93.5156 228.125 117.266 228.125H182.742C206.875 228.125 220.312 214.531 220.312 190.313V109.609C220.312 85.7813 206.875 71.875 182.742 71.875Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.375 108.203V108.281C116.008 108.281 113.281 111.016 113.281 114.375C113.281 117.734 116.008 120.469 119.375 120.469H142.727C146.094 120.469 148.828 117.734 148.828 114.289C148.828 110.937 146.094 108.203 142.727 108.203H119.375ZM180.625 155.781H119.375C116.008 155.781 113.281 153.047 113.281 149.687C113.281 146.328 116.008 143.586 119.375 143.586H180.625C183.984 143.586 186.719 146.328 186.719 149.687C186.719 153.047 183.984 155.781 180.625 155.781ZM180.625 191.484H119.375C117.031 191.797 114.766 190.625 113.516 188.672C112.266 186.641 112.266 184.062 113.516 182.109C114.766 180.078 117.031 178.984 119.375 179.219H180.625C183.742 179.531 186.094 182.188 186.094 185.391C186.094 188.508 183.742 191.172 180.625 191.484Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.668b35319b0aea31a01d0960b70ec404.svg";
export { ForwardRef as ReactComponent };